export default {
  MAIL_TEMPLATES: "Mail Templates",
  MAIL_SETTINGS: "Mail Settings",
  MAIL_LOGS: "Mail Logs",

  ALL_CATEGORIES: "All categories",
  TRANSACTIONAL: "Transactional",
  NOTIFICATION: "Notification",
  MARKETING: "Marketing",

  ALL_STATUS: "All statuses",
  CUSTOMIZED: "Customized",
  USING_DEFAULT: "Using default",
  NO_MAIL_TYPES: "No mail types configured.",

  CUSTOMIZE: "Customize",
  CUSTOMIZE_CONFIRM: "Customize the template \u00ab{name}\u00bb? A copy of the default template will be created.",
  RESET_DEFAULT: "Reset to default",
  RESET_CONFIRM: "Remove your customization and revert to the default template?",
  EDIT_TEMPLATE: "Edit template",
  SEND_TEST: "Send test",
  SEND: "Send",
  TEST_EMAIL: "Test email address",

  TEMPLATE_CUSTOMIZED: "Template customized successfully",
  TEMPLATE_SAVED: "Template saved",
  TEMPLATE_RESET: "Template reset to default",
  TEST_SENT: "Test email sent",
  SETTINGS_SAVED: "Mail settings saved",

  SUBJECT: "Subject",
  SENDER_OVERRIDE: "Customize sender",
  FROM_EMAIL: "Sender email",
  FROM_NAME: "Sender name",
  REPLY_TO: "Reply to",
  REPLY_TO_NAME: "Reply to name",
  REPLY_TO_EMAIL: "Reply to email",
  VARIABLES: "Available variables",
  EMAIL_BUILDER: "Email Builder",
  SUBJECT_REQUIRED: "Subject is required",
  CONTENT_REQUIRED: "Content is required",
  VALIDATION_ERROR: "Validation error",

  SENDER_DEFAULTS: "Default sender",
  DEFAULT_LOCALE: "Default language",
  BRANDING: "Branding",
  LOGO_URL: "Logo URL",
  LOGO_HEIGHT: "Logo height (px)",
  PRIMARY_COLOR: "Primary color",
  SECONDARY_COLOR: "Secondary color",
  FOOTER: "Footer",
  FOOTER_TEXT: "Footer text",
  UNSUBSCRIBE_URL: "Unsubscribe link",

  RECIPIENT: "Recipient",
  TYPE: "Type",
  STATUS: "Status",
  ENTRIES: "entries",
  LANGUAGE: "Language",
  SELECT_ORGANIZATION: "Select an organization to view its mail templates.",
  TEMPLATES_LIST: "Templates list",
  CATEGORY: "Category",
  LANGUAGES: "Languages",
  REPLY_TO_NAME: "Reply to name",
  OVERRIDES: "Overrides",
  VIEW_IN_ORGANIZATION: "View in organization",
  EDIT_DEFAULT: "Edit default template",
  EDIT_CUSTOMIZATION: "Edit customization",
  DEFAULT_TEMPLATE_SAVED: "Default template updated",

  // Log statuses
  STATUS_SENT: "Sent",
  STATUS_FAILED: "Failed",
  STATUS_PENDING: "Pending",
  STATUS_OPENED: "Opened",
  STATUS_CLICKED: "Clicked",
  STATUS_BOUNCED: "Bounced",
  LOCALE: "Locale",
  ADD_TEMPLATE_MAIL: "Add mail type",
  MAIL_TYPE_CREATED: "Mail type created",
  CODE: "Code",
  DESCRIPTION: "Description",
  NAME_AND_DESCRIPTION: "Name and description per language",
  ADD_VARIABLE: "Add variable",
  NO_VARIABLES_YET: "No variables added yet. Click the button to add one.",
  GROUP: "Group",
  NO_MATCH: "No matching variable",

  // Validation
  FIELD_REQUIRED: "This field is required.",
  PLEASE_FIX_ERRORS: "Please fix the errors in the form.",
  NAME_REQUIRED_FOR: "Name is required for language {locale}.",

  // Type settings
  TYPE_SETTINGS: "Type settings",
  TYPE_SETTINGS_SAVED: "Type settings saved",

  DEFAULT: "Default",
  PREVIEW: "Preview",

  // Layouts
  MAIL_LAYOUTS: "Mail Layouts",
  EDIT_LAYOUT: "Edit layout",
  LAYOUT_SAVED: "Layout saved",
  LAYOUT_CREATED: "Layout created",
  ADD_LAYOUT: "Add layout",
  SET_AS_DEFAULT: "Set as default",
  LAYOUT_NAME: "Layout name",
  NO_LAYOUTS: "No layouts configured.",
  SOURCE: "Source",
  PREVIEW_WITH_ORG: "Preview with organization",
  LAYOUT_SLOTS_HELP: "Available slots: {{ content }}, {{ headerContent }}, {{ footerContent }}, {{ unsubscribeContent }}, {{ brandColor }}, {{ organizationName }}, {{ currentYear }}, {{ customCss }}, {{ logoHeight }}",

  // Copy locale
  COPY_FROM: "Copy from",
  COPY_FROM_LOCALE: "Copy content from another language",
  COPY_FROM_LOCALE_TO: "Copy {from} → {to}",
  LOCALE_COPIED: "Content copied from {from} to {to}",
};
